import {
	BreadcrumbCompat as Breadcrumb,
	ChoiceGroupCompat as ChoiceGroup,
	DefaultButtonCompat as DefaultButton,
	DialogCompat as Dialog,
	DialogFooterCompat as DialogFooter,
	DialogType,
	IconCompat as Icon,
	IconButtonCompat as IconButton,
	type IBreadcrumbItem,
	type IChoiceGroupOption,
	type IDropdownOption,
	type IRawStyle,
	type ITextStyles,
	PrimaryButtonCompat as PrimaryButton,
	SelectionMode,
	StackCompat as Stack,
	TextCompat as Text,
	mergeStyles,
} from 'components/FluentUICompat';
import {useGetRegDocAllParagraphsQuery} from '../hooks/useGetRegDocAllParagraphs.generated';
import {useBoolean} from '@fluentui/react-hooks';
import {useUserContext} from 'authentication/UserContext';
import {
	checkSearchValid,
	DetailsField,
	DetailsSection,
	HEIGHT_OF_LIST_HEADER,
	PdfViewer,
} from 'components';
import {AuditLogsLoadingStatusProvider} from 'components/ChangeHistory/AuditLogsLoadingStatusProvider';
import {CommentForm} from 'components/CommentForm';
import {CommentLevel} from 'components/CommentList';
import {FAQForm} from 'components/FAQForm';
import {FAQLevel} from 'components/FAQList';
import {useSortRegulatoryDocs} from 'features/Regulations/components/useSortRegulatoryDocs';
import {RegDocParagraphTooltipTranslationProvider} from 'features/localizedTooltips';
import {mapToRef} from 'helpers';
import {
	StateForShouldShowAudit,
	useCommand,
	useFavoriteCommand,
	useShouldShowAudit,
} from 'hooks';
import {useToggleAuditCmd} from 'hooks/audit/useToggleAuditCmd';
import React, {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from 'react';
import {useForm} from 'react-hook-form';
import {TFunction, useTranslation} from 'react-i18next';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {
	DocumentStatus,
	Market,
	RegulatoryDocument,
	RegulatoryDocumentParagraph,
	UserRole,
	Workflow,
	WorkflowStatus,
} from 'types';
import ParagraphsComparisonPanel from '../ParagraphsComparisonPanel';
import {SidePaneForParagraphs} from '../SidePaneForParagraphs';
import {CompareVersionPanel} from '../components/DocumentCompare';
import {
	CompareversionForm,
	EditParagraphsForm,
	KeywordAssignmentForm,
	ParagraphTableOfContents,
	RemoveRequirementsForm,
	ViewParagraphsForm,
	WorkflowDialog,
} from '../components/DocumentDetails';
import {AssignRequirementsForm} from '../components/DocumentDetails/AssignRequirementsForm';
import {
	ParagraphsContextProvider,
	useParagraphsContext,
} from '../components/DocumentDetails/ParagraphsContext';
import {RegulatoryDocumentsForm} from '../components/RegulatoryDocumentsForm/RegulatoryDocumentsForm';
import {
	RegulatoryDocumentFormInfo,
	useRegulatoryDocumentForm,
} from '../components/RegulatoryDocumentsForm/useRegulatoryDocumentForm';
import {
	EditorSelectionContextProvider,
	RegulatoryDocumentsContextProvider,
} from '../context';
import {useAssignRegulatoryDocumentParagraphsTagsMutation} from '../hooks/useAssginRegulatoryDocumentParagraphsTag.generated';
import {useAssignRegulatoryDocumentParagraphsRequirementsMutation} from '../hooks/useAssignRegulatoryDocumentParagraphsRequirement.generated';
import {
	GetRegulatoryDocumentDetailsDocument,
	GetRegulatoryDocumentDetailsQuery,
	GetVexRegulatoryDocumentParagraphsDocument,
	GetVexRegulatoryDocumentParagraphsQuery,
	useGetVexRegulatoryDocumentParagraphsQuery,
} from '../hooks/useGetRegulatoryDocumentDetails.generated';
import {useCreateInterimRequirementMutation} from '../hooks/useCreateInterimRequirment.generated';
import {useGetexMutations} from './useGetexMutations';
import {getStackHeight} from '../paragraphsComparisonStyles';
import {
	getIfDocHasUneditableStatus,
	useEditRegulatoryDocCmd,
} from '../useEditRegulatoryDocCmd';
import {
	EditParagraphsFormSubmissionStatusContext,
	EditParagraphsFormSubmissionStatusInfo,
	EditParagraphsFormSubmissionStatusProvider,
} from './EditParagraphsFormSubmissionStatusProvider';
import {RegDocDetailsPageLoadWrapper} from './LoadWrapper/RegDocDetailsPage.LoadWrapper';
import {ParagraphFieldsSortingService} from './ParagraphFieldsSorting.service';
import {buildRegulatoryDocumentFieldRows} from './RegDocDetailsFields';
import {RegDocDetailsPageParagraphsList} from './RegDocDetailsPage.ParagraphsList';
import {useRegDocDetailsPageTranslations} from './RegDocDetailsPage.commonHooks';
import {HEIGHT_OF_PARAGRAPHS_SECTION_HEADER} from './RegDocDetailsPage.constants';
import {RegDocDetailsPageInfoProvider} from './RegDocDetailsPage.context';
import {DocOfRegDocDetailsPageQuery} from './RegDocDetailsPage.queryTypes';
import {RefToContainerOfMainParagraphs} from './RegDocDetailsPage.types';
import {RegDocSidebarInfoProvider} from './RegDocSidebarInfoProvider';
import {ViewPdfButton} from './ViewPdfButton';
import {
	RegDocAuditLogsInfo,
	useGetRegDocAuditLogs,
} from './useGetRegDocAuditLogs';
import {
	getCorrectStatusName,
	getDisabledEditionForMOdifiedVersionTooltip,
	isRegDocEditDisabled,
	isRegDocEditVersionDataDisabled,
} from '../regulatoryUtils';
import {DocumentSourceEnum} from 'features/Regulations/RegulationDetail/RegulationDetail.types';
import {EntityListContextProvider} from 'components/EntityList/EntityListContext';
import {EntityContextProvider} from 'components/EntityPage/EntityContext';
import {ParagraphGridView} from '../components/GridView/ParagraphGridView';
import {RegulatoryDocumentsCollectionName} from 'components/Faq/EntityTypeMapper';
import {useQuestionCountsByEntityTypeQuery} from 'components/Faq/Faq.generated';
import {FaqPanelMode} from 'components/Faq/FaqPanel';
import useQuestionsPermissions from 'components/Faq/hooks/useQuestionsPermissions';
import {IComparedItem} from '../components/DocumentCompare/compareDocuments/compareDocuments';
import {useParagraphMetadataUpdader} from '../hooks/useParagraphMetadataUpdater';
import {ComparisonUpdateFields} from '../components/DocumentCompare/CompareVersionPanel/compareVersionTypes';
import {useSearchParagraphsByRegDocIdLazyQuery} from 'features/Search/hooks/useFullTextSearch.generated';
import {useDismantleGetexRegulationAttachmentMutation} from 'features/GetexRegulation/hooks/GetexDismantleAttachment.generated';
import {useInjectedData} from './useInjectedData';
import {RegulatoryDocumentJSONForm} from '../components/RegulatoryDocumentJSONForm';

export const RegulatoryDocumentDetailsPage: React.FC = () => {
	return (
		<ParagraphsContextProvider>
			<EditorSelectionContextProvider>
				<EditParagraphsFormSubmissionStatusProvider>
					<RegulatoryDocumentDetailsPageComponent />
				</EditParagraphsFormSubmissionStatusProvider>
			</EditorSelectionContextProvider>
		</ParagraphsContextProvider>
	);
};

const useEnumTranslation = (keyPrefix: string) => {
	return useTranslation('common/enums', {keyPrefix});
};

// eslint-disable-next-line complexity
const RegulatoryDocumentDetailsPageComponent: React.FC = () => {
	/**
	 * Translations
	 */
	const {t} = useRegDocDetailsPageTranslations();
	const {t: getWorkflowStatus} = useEnumTranslation('WorkflowStatus');
	const {t: getStatusTranslation} = useEnumTranslation(
		'RegulatoryDocumentStatus',
	);
	const {t: tPogis} = useTranslation('features/pogisdocuments', {
		keyPrefix: 'Reference',
	});
	const {t: getDisassemblyStatusTranslation} = useEnumTranslation(
		'RegulatoryDocumentDisassemblyStatus',
	);

	const [createInterimRequirement] = useCreateInterimRequirementMutation();
	const [searchParagraphs, {loading: loadingSearch, data: dataSearch}] =
		useSearchParagraphsByRegDocIdLazyQuery();
	/**
	 * Other hooks
	 */
	const {shouldShowFaq} = useQuestionsPermissions();
	const {updateParagraphMetadata} = useParagraphMetadataUpdader();
	const [isFormRefetchingRegDoc, setIsFormRefetchingRegDoc] =
		useState<boolean>(false);
	const navigate = useNavigate();
	const {isVex, isVko, myVexClusters, isAdmin, username, encodedUserId} =
		useUserContext();

	const myVexClusterIds = myVexClusters.flatMap(c => c.id);

	const [sideBySide, setSideBySide] = React.useState<RegulatoryDocument>();
	const handleSideBySideChange = (newValue: RegulatoryDocument) => {
		setSideBySide(newValue);
	};

	const [viewPdf, {toggle: toggleViewPdf}] = useBoolean(false);
	const [viewGrid, setViewGrid] = useState(false);

	const [tocIsOpen, {setFalse: hideToc, toggle: toggleToc}] = useBoolean(false);
	const {
		textStyles,
		stackStyles,
		stackshit,
		mainParagraphsWrapper,
		pdfParagraphsListWrapper,
	} = getStyles(Boolean(sideBySide) || viewPdf);

	const stateForShouldShowAudit: StateForShouldShowAudit = useShouldShowAudit();
	const [showAudit] = stateForShouldShowAudit;

	const {regulatoryDocumentId: docIdWithoutType} = useParams();
	const docId = docIdWithoutType as string;

	const {
		injectedData,
		isGetexInjected,
		isRegDocLoading,
		data,
		regDocNetworkStatus,
	} = useInjectedData(docId);

	const {updateWorkflowStatus} = useGetexMutations();

	const [
		isDismantleDialogOpen,
		{setTrue: openDismantleDialog, setFalse: closeDismantleDialog},
	] = useBoolean(false);
	const [
		isDismantleInfoDialogOpen,
		{setTrue: openDismantleInfoDialog, setFalse: closeDismantleInfoDialog},
	] = useBoolean(false);
	const [selectedAttachmentId, setSelectedAttachmentId] = useState<
		string | undefined
	>(undefined);
	const [dismantleAttachment] = useDismantleGetexRegulationAttachmentMutation();
	const {t: tGetex} = useTranslation('features/getexregulation', {
		keyPrefix: 'GetexDetailsPage',
	});

	const [searchParams] = useSearchParams();

	const filter = searchParams.get('filter') ?? '';
	const searchString = searchParams.get('text') ?? '';

	const refToContainerOfMainParagraphs: RefToContainerOfMainParagraphs =
		useRef(null);

	/**
	 * Queries
	 */

	const [assignRegulatoryDocumentParagraphsRequirements] =
		useAssignRegulatoryDocumentParagraphsRequirementsMutation();

	const [assignRegulatoryDocumentParagraphsTags] =
		useAssignRegulatoryDocumentParagraphsTagsMutation();

	const {
		data: vexItems,
		loading: vexItemsLoading,
		networkStatus: vexItemsNetworkStatus,
	} = useGetVexRegulatoryDocumentParagraphsQuery({
		variables: {regulatoryDocumentId: docId, inProcess: filter === 'inProcess'},
		skip: isGetexInjected,
		notifyOnNetworkStatusChange: true,
	});

	const {
		auditLogs,
		refetchAuditLogsAndUpdateIsLoading,
		isLoading: areAuditLogsLoading,
		setAreAuditLogsLoading,
	}: RegDocAuditLogsInfo = useGetRegDocAuditLogs(docId);

	/**
	 * Other
	 */
	const {sortParagraphs} = new ParagraphFieldsSortingService();

	// Query for all uses: grid view, side-by-side, filters, search, TOC
	// Skip this query when using Getex injected data (has separate endpoint)
	const {data: allRegDocParagraphsData} = useGetRegDocAllParagraphsQuery({
		variables: {regulatoryDocumentId: docId},
		skip: !docId || isGetexInjected,
	});

	type VexRegDocParagraphs =
		GetVexRegulatoryDocumentParagraphsQuery['vexRegulatoryDocumentParagraphs'];

	const getVexWorkbenchItems = (): VexRegDocParagraphs => {
		const paragraphs: VexRegDocParagraphs =
			vexItems?.vexRegulatoryDocumentParagraphs ?? [];
		return sortParagraphs(paragraphs);
	};

	// Get all paragraphs for TOC (same source as main list for sync)
	// For Getex, uses injected data; for RegDoc, uses separate query
	const getTocParagraphsList = (): RegulatoryDocumentParagraph[] => {
		if (isGetexInjected && injectedData?.getexParagraphs) {
			return injectedData.getexParagraphs as RegulatoryDocumentParagraph[];
		}
		return (allRegDocParagraphsData?.regulatoryDocument?.paragraphs ?? []) as RegulatoryDocumentParagraph[];
	};

	const vexWorkbenchItems: VexRegDocParagraphs = React.useMemo(
		getVexWorkbenchItems,
		[sortParagraphs?.length, vexItems?.vexRegulatoryDocumentParagraphs],
	);

	const [showWorkbenchItems, setShowWorkbenchItems] = React.useState(
		(isVex && vexWorkbenchItems.length > 0) ?? false,
	);

	const getRegulatoryDocumentDetails = () => {
		type RegDoc = GetRegulatoryDocumentDetailsQuery['regulatoryDocument'];
		const regDoc: RegDoc = data?.regulatoryDocument;
		if (regDoc) return regDoc;
		return {} as RegulatoryDocument;
	};

	const regulatoryDocumentDetails = React.useMemo(
		getRegulatoryDocumentDetails,
		[data],
	);

	const handleDismantleConfirm = async () => {
		if (!selectedAttachmentId) return;
		await dismantleAttachment({
			variables: {
				input: {documentId: docId, attachmentId: selectedAttachmentId},
			},
		});
		setSelectedAttachmentId(undefined);
		closeDismantleDialog();
		openDismantleInfoDialog();
	};

	const handleDismantleCancel = () => {
		setSelectedAttachmentId(undefined);
		closeDismantleDialog();
	};

	const attachmentChoiceOptions: IChoiceGroupOption[] = (
		regulatoryDocumentDetails.attachments ?? []
	).map(a => ({
		key: a.attachmentId,
		text: a.file.originalFileName ?? a.file.fileName ?? a.attachmentId,
	}));

	const comments = React.useMemo(
		() => regulatoryDocumentDetails.comments,
		[regulatoryDocumentDetails],
	);

	const faqs = React.useMemo(() => {
		const faqsData = regulatoryDocumentDetails.faqs;
		return faqsData;
	}, [regulatoryDocumentDetails]);

	const {data: questionSummaryData} = useQuestionCountsByEntityTypeQuery({
		variables: {
			entityType: RegulatoryDocumentsCollectionName,
			parentId: regulatoryDocumentDetails?.regulation?.id,
		},
	});

	const isPogisDocument = React.useMemo(
		() =>
			regulatoryDocumentDetails.documentSource?.name?.toLowerCase() ===
			DocumentSourceEnum.Pogis.toLowerCase(),
		[regulatoryDocumentDetails],
	);

	const {
		selectedParagraphs,
		setSelectedParagraphs,
		secondSelectedParagraphs,
		filteredParagraphs,
		setIndexToScrollTo,
	} = useParagraphsContext();

	React.useEffect(() => {
		setShowWorkbenchItems(isVex && vexWorkbenchItems.length > 0);
	}, [isVex, vexWorkbenchItems]);

	const needsLegacyParagraphArray =
		showWorkbenchItems ||
		viewGrid ||
		Boolean(sideBySide) ||
		filteredParagraphs.length > 0 ||
		checkSearchValid(searchString) ||
		selectedParagraphs.length > 0;

	const paragraphs = React.useMemo(() => {
		if (showWorkbenchItems) {
			return vexWorkbenchItems as RegulatoryDocumentParagraph[];
		}

		if (needsLegacyParagraphArray) {
			return (allRegDocParagraphsData?.regulatoryDocument?.paragraphs ?? []) as RegulatoryDocumentParagraph[];
		}

		return [] as RegulatoryDocumentParagraph[];
	}, [
		needsLegacyParagraphArray,
		allRegDocParagraphsData?.regulatoryDocument?.paragraphs,
		showWorkbenchItems,
		vexWorkbenchItems,
	]);

	React.useEffect(() => {
		if (checkSearchValid(searchString)) {
			searchParagraphs({
				variables: {regulatoryDocumentId: docId, searchString},
			});
		}
	}, [searchString]);

	const paragraphListItems = React.useMemo(() => {
		if (filteredParagraphs.length > 0) {
			return filteredParagraphs;
		}

		if (checkSearchValid(searchString)) {
			const searchedParaIDs =
				dataSearch?.searchParagraphsForRegDoc.map(x => x.id) ?? [];
			return (paragraphs ?? []).filter(x => searchedParaIDs?.includes(x.id));
		}

		return paragraphs;
	}, [filteredParagraphs, paragraphs, dataSearch, searchString]);

	const tocFilteredParagraphIds = React.useMemo(
		() => filteredParagraphs.map(p => p.id),
		[filteredParagraphs],
	);

	const allParagraphsForSelectAll = React.useMemo(() => {
		const all = getTocParagraphsList();
		if (tocFilteredParagraphIds.length === 0) {
			return all;
		}
		const tocSet = new Set(tocFilteredParagraphIds);
		return all.filter(p => tocSet.has(p.id));
	}, [getTocParagraphsList, tocFilteredParagraphIds]);

	const paragraphListKey = React.useMemo(
		() => `regdoc-paragraphs-${tocFilteredParagraphIds.join(',')}`,
		[tocFilteredParagraphIds],
	);

	// We need this in order to update the SelectedParagraphs if there are changes in the data
	React.useEffect(() => {
		if (!paragraphListItems) return;
		const selectedParagraphsIds = new Set(selectedParagraphs.map(x => x.id));
		const selectedParagraphsUpdatedValues = paragraphListItems.filter(x =>
			selectedParagraphsIds.has(x.id),
		);
		const currentSelectionSignature = selectedParagraphs
			.map(p => p.id)
			.join('|');
		const updatedSelectionSignature = selectedParagraphsUpdatedValues
			.map(p => p.id)
			.join('|');

		if (currentSelectionSignature === updatedSelectionSignature) {
			return;
		}

		setSelectedParagraphs(selectedParagraphsUpdatedValues);
	}, [paragraphListItems, selectedParagraphs, setSelectedParagraphs]);

	const allBreadCrumbItems: IBreadcrumbItem[] = [
		{
			text: t('Regulations'),
			key: 'regulations',
			href: '/regulations',
		},
		{
			text: `${regulatoryDocumentDetails?.regulation?.regulationNumber}`,
			key: 'regulatoryDocument',
			href: `/regulations/${regulatoryDocumentDetails?.regulation?.id}`,
		},
		{
			text: `${regulatoryDocumentDetails?.name}`,
			key: 'name',
		},
	];

	const headlessBreadCrumbItems: IBreadcrumbItem[] = [
		{
			text: t('RegulatoryDocuments'),
			key: 'regulatoryDocuments',
		},
		{
			text: `${regulatoryDocumentDetails?.name}`,
			key: 'name',
		},
	];

	const findDocumentValue = <
		Key extends keyof typeof regulatoryDocumentDetails,
	>(
		key: Key,
	): RegulatoryDocument[Key] | undefined => {
		return regulatoryDocumentDetails?.[key];
	};

	const getStatusValue = (): DetailsField['data'] => {
		const status: RegulatoryDocument['status'] | undefined =
			findDocumentValue('status');
		return status ? getStatusTranslation(status) : null;
	};

	const getDisassemblyStatusValue = (): DetailsField['data'] => {
		const status: RegulatoryDocument['disassemblyStatus'] | undefined =
			findDocumentValue('disassemblyStatus');
		return status ? getDisassemblyStatusTranslation(status) : null;
	};

	const {control: WorkflowStatusControl} = useForm<Workflow>({
		reValidateMode: 'onSubmit',
		mode: 'onBlur',
	});

	const handleWorkflowStatusChange = useCallback(
		async (
			_event: React.FormEvent<HTMLDivElement>,
			option?: IDropdownOption,
		) => {
			if (option === undefined) {
				return;
			}

			const updateFn = updateWorkflowStatus(
				regulatoryDocumentDetails.id,
				option.key as WorkflowStatus,
			);

			await updateFn
				.then(() => {
					if (option.key === WorkflowStatus.Finalized) {
						createInterimRequirement({
							variables: {regulatoryDocumentId: regulatoryDocumentDetails.id},
						});
					}
				})
				.then(() => window.location.reload());
		},
		[updateWorkflowStatus, regulatoryDocumentDetails.id],
	);

	const reapprovingHistoryMessages = React.useMemo(
		() =>
			auditLogs
				.filter(
					log =>
						log.change.key === 'reapprovingMessage' &&
						log.change.value &&
						['ADD', 'UPDATE'].indexOf(log.change.type) !== -1,
				)
				.sort((log1, log2) =>
					new Date(log1.createdAt).getTime() <
					new Date(log2.createdAt).getTime()
						? 1
						: -1,
				)
				.map(log => {
					return {
						date: new Date(log.createdAt),
						value: log.change.value,
					};
				}),
		[auditLogs],
	);

	const attachmentFaqLine = React.useMemo(() => {
		const attachmentField = {
			data: regulatoryDocumentDetails.attachments,
			type: 'attachments' as const,
			label: t('AttachmentsLabel'),
			rowNumber: 5,
		};
		return shouldShowFaq
			? [
					attachmentField,
					{
						data: {
							...questionSummaryData?.questionCountsByEntityType?.find(
								t => t.entityId === docId,
							),
							faqState: {
								mode: FaqPanelMode.RegDocDetails,
								entity: regulatoryDocumentDetails,
								showPanel: true,
							},
							text: t('FaqText'),
						},
						type: 'faq' as const,
						label: t('FaqLabel'),
					},
			  ]
			: [attachmentField];
	}, [
		docId,
		questionSummaryData?.questionCountsByEntityType,
		regulatoryDocumentDetails.attachments,
		shouldShowFaq,
		t,
	]);

	const regDocFieldRows: DetailsField[][] = React.useMemo(
		() =>
			buildRegulatoryDocumentFieldRows({
				regulatoryDocumentDetails: regulatoryDocumentDetails as any,
				t,
				tPogis,
				getWorkflowStatus,
				showAudit,
				isAdmin,
				reapprovingHistoryMessages,
				areAuditLogsLoading,
				getCorrectStatusName,
				getStatusValue,
				getDisassemblyStatusValue,
				WorkflowStatusControl,
				handleWorkflowStatusChange,
				attachmentFaqLine: attachmentFaqLine as any,
				tDisclaimer: t('Disclaimer'),
				isGetexInjected,
				traceKeywords: injectedData?.getexExtras?.traceKeywords,
				vehicleCategories: injectedData?.getexExtras?.vehicleCategories,
			}),
		[
			regulatoryDocumentDetails,
			showAudit,
			t,
			getWorkflowStatus,
			auditLogs,
			areAuditLogsLoading,
			questionSummaryData,
			attachmentFaqLine,
			isAdmin,
			reapprovingHistoryMessages,
			isGetexInjected,
			injectedData?.getexExtras?.traceKeywords,
			injectedData?.getexExtras?.vehicleCategories,
		],
	);

	const generalTabFieldLabels = React.useMemo(
		() => [
			t('ShortSummaryLabel'),
			t('ChangeHistoryLabel'),
			t('StatusLabel'),
			t('Approver'),
			t('WorkflowStatus'),
			tPogis('AlreadyCommunicated'),
			tPogis('pogisDocuments'),
			t('DisassemblyStatus'),
			t('DocumentSourceLabel'),
			t('AttachmentsLabel'),
			t('CreationDateLabel'),
			t('ChangeDateLabel'),
			t('KeywordsLabel'),
			t('TraceKeywordsLabel'),
			t('GetexSectionHeader'),
		],
		[t, tPogis],
	);

	const dateFieldsLabels = React.useMemo(
		() => [
			t('EffectiveDateLabel'),
			t('ExpirationDateLabel'),
			t('NewTypesLabel'),
			t('NewRegistrationLabel'),
			t('PhaseInLabel'),
			t('PhaseOutLabel'),
			t('ModelYearLabel'),
		],
		[t],
	);

	const referenceFieldLabels = React.useMemo(
		() => [t('DocumentReferences'), t('DocumentReferencedBy')],
		[t],
	);

	/**
	 * * Commands
	 */
	const {isSubmitting} = useContext(
		EditParagraphsFormSubmissionStatusContext,
	) as EditParagraphsFormSubmissionStatusInfo;
	const [paragraphsListKey, setParagraphsListKey] = useState(0);
	const wasSubmittingRef = useRef(false);

	useEffect(() => {
		if (wasSubmittingRef.current && !isSubmitting) {
			setParagraphsListKey(prev => prev + 1);
		}

		wasSubmittingRef.current = isSubmitting;
	}, [isSubmitting]);

	useCommand(
		{
			key: 'close',
			text: t('CancelSecondVersion'),
			farCommand: true,
			onClick() {
				setSideBySide(undefined);
			},
			iconProps: {
				iconName: 'Cancel',
			},
			hidden: !sideBySide || isGetexInjected,
		},
		[sideBySide],
	);

	/**
	 * If you wish to pass any props to the button, edit the btn component
	 * directly. If you define props here, they might not be passed
	 */

	useCommand(
		{
			key: 'pdfView',
			farCommand: true,
			priority: 1,
			hidden:
				!regulatoryDocumentDetails.document ||
				isPogisDocument ||
				regulatoryDocumentDetails.documentStatus === DocumentStatus.NotSplit ||
				viewGrid ||
				isGetexInjected,
			roles: [
				UserRole.SystemAdministrator,
				UserRole.Vko,
				UserRole.Vex,
				UserRole.VexSupport,
				UserRole.ServiceProvider,
				UserRole.ShApprover,
				UserRole.Readers,
				UserRole.RegulationReader,
				UserRole.Bav,
				UserRole.Bedarfskoordinator,
				UserRole.Avk,
			],
			commandBarButtonAs(): React.ReactElement {
				return (
					<ViewPdfButton
						viewPdf={viewPdf}
						togglePdf={toggleViewPdf}
						sideBySide={sideBySide}
						doc={regulatoryDocumentDetails.document}
						refToContainerOfMainParagraphs={refToContainerOfMainParagraphs}
						setIndexToScrollTo={setIndexToScrollTo}
					/>
				);
			},
		},
		[
			viewPdf,
			viewGrid,
			sideBySide,
			regulatoryDocumentDetails.document,
			toggleViewPdf,
			refToContainerOfMainParagraphs,
			setIndexToScrollTo,
		],
	);

	useCommand(
		{
			key: 'copyRequirements',
			text: t('CopyRequirements'),
			priority: 7,
			onClick() {
				const myVexClusterRequirements =
					secondSelectedParagraphs[0]?.requirements?.filter(r =>
						r.vexClusters?.find(v => myVexClusterIds?.includes(v.id)),
					);

				assignRegulatoryDocumentParagraphsRequirements({
					variables: {
						input: {
							paragraphIds: selectedParagraphs?.map(sp => sp.id),
							regulatoryDocumentId: docId,
							requirementRefs: mapToRef(
								isVex
									? myVexClusterRequirements
									: secondSelectedParagraphs[0]?.requirements,
							),
						},
					},
					refetchQueries: [GetVexRegulatoryDocumentParagraphsDocument],
				});
			},
			hidden: !sideBySide || isPogisDocument || isGetexInjected,
			disabled: !(
				selectedParagraphs.length > 0 && secondSelectedParagraphs.length === 1
			),
			iconProps: {
				iconName: 'Copy',
			},
		},
		[sideBySide, selectedParagraphs, secondSelectedParagraphs, isVex],
	);

	useCommand(
		{
			key: 'copyTags',
			text: t('CopyTags'),
			priority: 8,
			onClick() {
				assignRegulatoryDocumentParagraphsTags({
					variables: {
						input: {
							paragraphIds: selectedParagraphs?.map(sp => sp.id),
							regulatoryDocumentId: docId,
							tagRefs: mapToRef(secondSelectedParagraphs[0].tags),
						},
					},
					refetchQueries: [GetVexRegulatoryDocumentParagraphsDocument],
				});
			},
			hidden: !sideBySide || isGetexInjected,
			disabled:
				!(
					selectedParagraphs.length > 0 && secondSelectedParagraphs.length === 1
				) || isPogisDocument,
			iconProps: {
				iconName: 'Copy',
			},
		},
		[sideBySide, selectedParagraphs, secondSelectedParagraphs],
	);
	useCommand(
		{
			key: 'gridView',
			text: t('GridView'),
			hidden:
				viewGrid ||
				![
					WorkflowStatus.Clearing,
					WorkflowStatus.ClearingWithReservations,
					WorkflowStatus.Examination,
					WorkflowStatus.InProgressInternal,
					WorkflowStatus.InProgressExternal,
					WorkflowStatus.Modified,
				].includes(regulatoryDocumentDetails?.workflow?.status) ||
				isGetexInjected,
			disabled: isRegDocEditDisabled(
				regulatoryDocumentDetails,
				isVko,
				encodedUserId,
			),
			onClick() {
				setViewGrid(true);
			},
			farCommand: true,
			priority: -1,
			roles: [UserRole.SystemAdministrator, UserRole.Vko],
			iconProps: {
				iconName: 'GridViewSmall',
			},
		},
		[viewGrid, regulatoryDocumentDetails],
	);

	useFavoriteCommand(docId, [], {hidden: isGetexInjected});

	useCommand(
		{
			key: 'workbenchItems',
			farCommand: true,
			priority: 0,
			onClick() {
				setShowWorkbenchItems(!showWorkbenchItems);
			},
			hidden: !isVex || isPogisDocument || isGetexInjected,
			iconProps: {iconName: 'Workflow'},
			title: showWorkbenchItems ? t('ShowAllParagraphsTooltip') : '',
		},
		[showWorkbenchItems, isVex],
	);

	useCommand(
		{
			key: 'openDocument',
			text: t('OpenEditor'),
			priority: 5,
			iconProps: {
				iconName: 'OpenFile',
			},
			onClick() {
				navigate(
					`/regulations/${regulatoryDocumentDetails?.regulation?.id}/${docIdWithoutType}`,
				);
			},
			hidden:
				(regulatoryDocumentDetails?.workflow?.status !== WorkflowStatus.New &&
					regulatoryDocumentDetails?.workflow?.status !==
						WorkflowStatus.QualityControlInternal &&
					regulatoryDocumentDetails?.workflow?.status !==
						WorkflowStatus.QualityControlExternal) ||
				isPogisDocument ||
				isVko ||
				isGetexInjected,
			disabled:
				regulatoryDocumentDetails?.workflow?.status ===
				WorkflowStatus.Finalized,
			roles: [
				UserRole.SystemAdministrator,
				UserRole.Vko,
				UserRole.ServiceProvider,
			],
		},
		[docIdWithoutType, regulatoryDocumentDetails, navigate],
	);

	useToggleAuditCmd(stateForShouldShowAudit, {hidden: isGetexInjected});

	useCommand(
		{
			key: 'dismantleGetex',
			text: tGetex('DismantleButton'),
			iconProps: {iconName: 'Repair'},
			onClick: openDismantleDialog,
			disabled: !regulatoryDocumentDetails.attachments?.length,
			hidden: !isGetexInjected,
		},
		[isGetexInjected, regulatoryDocumentDetails.attachments?.length],
	);

	/**
	 * Edit form
	 */
	const formInfo: RegulatoryDocumentFormInfo = useRegulatoryDocumentForm();
	const {
		modeStateInfo: {setMode},
		documentChangeStateInfo: {setDidDocumentChange},
	} = formInfo;

	const {regulation} = regulatoryDocumentDetails;

	const isEditVersionDataDisabled = useMemo(() => {
		return (
			getIfDocHasUneditableStatus(
				regulatoryDocumentDetails,
				isAdmin,
				username,
			) ||
			isRegDocEditVersionDataDisabled(
				regulatoryDocumentDetails,
				isAdmin,
				isVko,
				encodedUserId,
			) ||
			isSubmitting
		);
	}, [
		regulatoryDocumentDetails,
		isAdmin,
		username,
		encodedUserId,
		isSubmitting,
	]);

	useEditRegulatoryDocCmd({
		setDidDocumentChange,
		setMode,
		title: getDisabledEditionForMOdifiedVersionTooltip(
			regulatoryDocumentDetails,
			t,
		),
		key: 'editDoc',
		text: t('EditBtnLabel'),
		priority: 2,
		disabled: isEditVersionDataDisabled,
		hidden: isPogisDocument || viewGrid,
		extraDependencies: [isEditVersionDataDisabled, viewGrid],
	});

	type DocRegulation = NonNullable<DocOfRegDocDetailsPageQuery['regulation']>;

	type PageRegulatoryDocs = DocRegulation['regulatoryDocuments'];

	type DocOfPageRegulatoryDocs = PageRegulatoryDocs[number];

	const sortedRegulatoryDocs: PageRegulatoryDocs =
		useSortRegulatoryDocs<DocOfPageRegulatoryDocs>({
			docs: regulatoryDocumentDetails.regulation?.regulatoryDocuments,
			extraDependencies: [regulatoryDocumentDetails],
		});

	/*
	 * Other
	 */
	const isLoading: boolean = isRegDocLoading || vexItemsLoading;

	const renderBaseParagraphSectionHeader = (): React.ReactElement => {
		return (
			<ParagraphsSectionHeader
				{...{
					filteredParagraphs,
					showWorkbenchItems,
					t,
					textStyles,
					toggleToc,
				}}
			/>
		);
	};

	const renderDefaultParagraphSectionHeader = (
		paragraphsHeader: React.ReactElement,
	): React.ReactElement => {
		return paragraphsHeader;
	};

	const renderPdfOrDefaultSectionHeader = (): React.ReactElement => {
		const sectionHeader: React.ReactElement =
			renderBaseParagraphSectionHeader();
		/**
		 * We show the base paragraphs header when we are loading. Otherwise, it
		 * will show on top of the load wrapper, which looks weird.
		 */
		return isLoading || viewPdf
			? sectionHeader
			: renderDefaultParagraphSectionHeader(sectionHeader);
	};

	const getAmountToScrollBackBy = (): number => {
		if (viewPdf) return HEIGHT_OF_LIST_HEADER;
		return HEIGHT_OF_LIST_HEADER + HEIGHT_OF_PARAGRAPHS_SECTION_HEADER;
	};

	const isReqIfz =
		regulatoryDocumentDetails.attachments?.some(a =>
			a.file.originalFileName?.toLocaleLowerCase().endsWith('.reqifz'),
		) ?? false;

	const pageDetails = useMemo(
		() => ({regulatoryDocumentDetails, reapprovingHistoryMessages}),
		[regulatoryDocumentDetails, reapprovingHistoryMessages],
	);

	const renderSectionHeaderAndParagraphs = (): React.ReactElement => {
		return (
			<>
				{renderPdfOrDefaultSectionHeader()}
				<RegDocParagraphTooltipTranslationProvider>
					<EntityListContextProvider pageDetails={pageDetails}>
						{viewGrid && (
							<ParagraphGridView
								regulatoryDocumentId={docId}
								paragraphsAll={paragraphs}
								paragraphsFiltered={paragraphListItems}
								setViewGrid={setViewGrid}
							/>
						)}
						{!viewGrid && (
							<EntityContextProvider>
								<RegDocDetailsPageParagraphsList
									key={`${paragraphListKey}-${paragraphsListKey}`}
									regulatoryDocumentId={docId}
									tocFilteredParagraphIds={tocFilteredParagraphIds}
									allParagraphsInScope={allParagraphsForSelectAll}
								/>
							</EntityContextProvider>
						)}
					</EntityListContextProvider>
				</RegDocParagraphTooltipTranslationProvider>
			</>
		);
	};

	const renderParagraphsPane = (): React.ReactElement => {
		return (
			<SidePaneForParagraphs extraStyle={pdfParagraphsListWrapper}>
				{renderSectionHeaderAndParagraphs()}
			</SidePaneForParagraphs>
		);
	};

	const renderMainParagraphs = (): React.ReactElement => {
		return (
			<div
				className={mergeStyles(mainParagraphsWrapper)}
				ref={refToContainerOfMainParagraphs}
			>
				{renderSectionHeaderAndParagraphs()}
			</div>
		);
	};

	if (!isGetexInjected && !isRegDocLoading && !data?.regulatoryDocument) {
		return (
			<h4 style={{marginTop: '50px', marginLeft: '20px'}}>
				{t('DocumentNotFound')}
			</h4>
		);
	}

	const onMetadataTransferred = (
		regDocId: string,
		items: IComparedItem[],
		selectedFields: ComparisonUpdateFields,
	) => {
		if (
			regulatoryDocumentDetails &&
			regDocId === regulatoryDocumentDetails.id
		) {
			items.forEach((item, index) => {
				const allParas = allRegDocParagraphsData?.regulatoryDocument?.paragraphs as any;
				if (allParas) {
					allParas[index] = updateParagraphMetadata(
						allParas[index] as RegulatoryDocumentParagraph,
						(item as any).newParagraph as RegulatoryDocumentParagraph,
						selectedFields,
					);
				}
			});
			setParagraphsListKey(prev => prev + 1);
		}
	};

	return (
		<RegDocDetailsPageInfoProvider
			isFormRefetchingRegDoc={isFormRefetchingRegDoc}
			isRegDocOrVexItemsLoading={isLoading}
			regDocNetworkStatus={regDocNetworkStatus}
			vexItemsNetworkStatus={vexItemsNetworkStatus}
			areVexItemsLoading={vexItemsLoading}
			regDoc={data}
			vexItems={vexItems}
		>
			<RegDocDetailsPageLoadWrapper>
				<RegulatoryDocumentsContextProvider
					regulatoryDocument={regulatoryDocumentDetails as any}
					sMode={SelectionMode.none}
				>
					<RegDocSidebarInfoProvider>
						{!sideBySide && !viewPdf && !viewGrid && (
							<>
								<div
									style={{
										position: 'sticky',
										top: 0,
										zIndex: 8,
										background: 'white',
									}}
								>
									<Breadcrumb
										items={
											injectedData?.breadcrumbItems ??
											(regulatoryDocumentDetails.regulation
												? allBreadCrumbItems
												: headlessBreadCrumbItems)
										}
									/>
								</div>
								<AuditLogsLoadingStatusProvider
									areAuditLogsLoading={areAuditLogsLoading}
								>
									<DetailsSection
										title={regulatoryDocumentDetails?.name}
										titleWithAudit={showAudit}
										initialFieldRows={regDocFieldRows}
										generalFieldLabels={generalTabFieldLabels}
										dateFieldLabels={dateFieldsLabels}
										referenceFieldLabels={referenceFieldLabels}
										useTabsForInitialFields={true}
										auditLogData={auditLogs}
									/>
								</AuditLogsLoadingStatusProvider>
							</>
						)}
						{!isPogisDocument && sideBySide ? (
							<Stack horizontal>
								<RegDocParagraphTooltipTranslationProvider>
									<ParagraphsComparisonPanel
										listId='firstList'
										paragraphs={paragraphs}
										tableId='regDocDetailsParagraphsList'
									/>
									<hr style={{margin: 10}} />
									<ParagraphsComparisonPanel
										listId='secondList'
										paragraphs={sideBySide.paragraphs}
										isSecondaryList={true}
										selectionMode={SelectionMode.single}
									/>
								</RegDocParagraphTooltipTranslationProvider>
							</Stack>
						) : (
							<Stack horizontal styles={viewPdf ? stackStyles : stackshit}>
								{viewPdf ? renderParagraphsPane() : renderMainParagraphs()}
								{viewPdf && regulatoryDocumentDetails.document?.uri && (
									<div style={{width: '50%'}}>
										<PdfViewer url={regulatoryDocumentDetails.document?.uri} />
									</div>
								)}
							</Stack>
						)}
						{!isPogisDocument && !viewGrid && (
							<>
								<WorkflowDialog
									regulatoryDocument={regulatoryDocumentDetails as any}
									refetchAuditLogs={refetchAuditLogsAndUpdateIsLoading}
								/>
								{regulatoryDocumentDetails?.workflow?.status !==
									WorkflowStatus.New && (
									<>
										<ViewParagraphsForm
											regulatoryDocument={regulatoryDocumentDetails}
										/>
										<EditParagraphsForm
											refetchAuditLogsAndUpdateIsLoading={
												refetchAuditLogsAndUpdateIsLoading
											}
											setAreAuditLogsLoading={setAreAuditLogsLoading}
											vexItems={vexItems}
											setIsFormRefetchingRegDoc={setIsFormRefetchingRegDoc}
											regDoc={regulatoryDocumentDetails}
											setIndexToScrollTo={setIndexToScrollTo}
										/>
										<AssignRequirementsForm />
										<RemoveRequirementsForm />
									</>
								)}
								<CommentForm
									comments={comments ?? []}
									level={CommentLevel.RegulatoryDocument}
								/>
								<FAQForm
									faqs={faqs ?? []}
									level={FAQLevel.RegulatoryDocument}
								/>
								<KeywordAssignmentForm />
								<CompareversionForm onValueChange={handleSideBySideChange} />
								<CompareVersionPanel
									regulationId={regulatoryDocumentDetails?.regulation?.id ?? ''}
									onTransferred={onMetadataTransferred}
								/>
								<RegulatoryDocumentsForm
									{...formInfo}
									regulatoryDocument={regulatoryDocumentDetails}
									regulationId={regulation?.id ?? null}
									regulatoryDocuments={sortedRegulatoryDocs}
									markets={
										(regulatoryDocumentDetails?.regulation?.markets ??
											[]) as Market[]
									}
									regulationNumber={regulation?.regulationNumber ?? ''}
									queriesToRefetchAfterSave={[
										GetRegulatoryDocumentDetailsDocument,
									]}
									fetchAndSetAuditLogs={refetchAuditLogsAndUpdateIsLoading}
								/>
							</>
						)}
						{!isPogisDocument && (
							<ParagraphTableOfContents
								isOpen={tocIsOpen}
								onDismiss={hideToc}
								visibleParagraphs={getTocParagraphsList()}
								allParagraphs={getTocParagraphsList()}
							/>
						)}
						{isGetexInjected && (
							<>
								<Dialog
									hidden={!isDismantleDialogOpen}
									onDismiss={handleDismantleCancel}
									dialogContentProps={{
										type: DialogType.normal,
										title: tGetex('DismantleDialogTitle'),
										subText: tGetex('DismantleDialogSubtext'),
									}}
									modalProps={{isBlocking: true}}
								>
									<ChoiceGroup
										options={attachmentChoiceOptions}
										selectedKey={selectedAttachmentId}
										onChange={(_e, option) =>
											setSelectedAttachmentId(option?.key)
										}
									/>
									<DialogFooter>
										<PrimaryButton
											onClick={handleDismantleConfirm}
											disabled={!selectedAttachmentId}
										>
											{tGetex('Confirm')}
										</PrimaryButton>
										<DefaultButton onClick={handleDismantleCancel}>
											{tGetex('Cancel')}
										</DefaultButton>
									</DialogFooter>
								</Dialog>
								<Dialog
									hidden={!isDismantleInfoDialogOpen}
									onDismiss={closeDismantleInfoDialog}
									dialogContentProps={{
										type: DialogType.normal,
										subText: tGetex('DismantleInfoMessage'),
									}}
									modalProps={{isBlocking: false}}
								>
									<DialogFooter>
										<PrimaryButton onClick={closeDismantleInfoDialog}>
											{tGetex('Ok')}
										</PrimaryButton>
									</DialogFooter>
								</Dialog>
							</>
						)}
						<RegulatoryDocumentJSONForm
							regulatoryDocumentDetails={
								regulatoryDocumentDetails as RegulatoryDocument
							}
						/>
					</RegDocSidebarInfoProvider>
				</RegulatoryDocumentsContextProvider>
			</RegDocDetailsPageLoadWrapper>
		</RegDocDetailsPageInfoProvider>
	);
};

interface HeaderProps {
	toggleToc: () => void;
	t: TFunction;
	showWorkbenchItems: boolean;
	textStyles: ITextStyles;
	filteredParagraphs: RegulatoryDocumentParagraph[];
}

const ParagraphsSectionHeader: React.FC<HeaderProps> = ({
	filteredParagraphs,
	showWorkbenchItems,
	t,
	textStyles,
	toggleToc,
}) => {
	return (
		<div
			style={{
				position: 'sticky',
				top: 36,
				zIndex: 7,
				background: 'white',
			}}
		>
			<Stack horizontal styles={{root: {marginBottom: -5}}}>
				<IconButton
					iconProps={{iconName: 'BulletedTreeList'}}
					onClick={toggleToc}
					title={t('TableOfContents')}
				/>
				<Text styles={textStyles} variant={'xLarge'}>
					{showWorkbenchItems ? t('MyParagraphsHeader') : t('ParagraphsHeader')}
				</Text>
				{filteredParagraphs.length > 0 && (
					<Icon
						iconName='Filter'
						title={t('ParagraphsFiltered')}
						styles={{root: {paddingTop: 8, paddingLeft: 8}}}
					/>
				)}
			</Stack>
		</div>
	);
};

const getStyles = (fullHeight: boolean) => {
	const stackHeight: IRawStyle['height'] = getStackHeight(fullHeight);

	return {
		pdfParagraphsListWrapper: {width: '50%'},
		mainParagraphsWrapper: {},
		textStyles: {
			root: {
				paddingLeft: 15,
			},
		},
		stackStyles: {root: {height: stackHeight}},
		stackshit: {
			root: {display: 'block'},
		},
	};
};

export default RegulatoryDocumentDetailsPage;
